import { render, staticRenderFns } from "./suggestBanners.vue?vue&type=template&id=4466ae42"
import script from "./suggestBanners.vue?vue&type=script&lang=js"
export * from "./suggestBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports